// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"94":"1a68b0a385b2a6518d0f","830":"4766a0afe776e226567b"}[chunkId] + ".css";
};